import Base from '../base';
import constructDialog from '../../utils/webcomponents/construct-dialog';

import './account-subscriptions-edit-form';

import accountEvents from './account-events';

// Input to trigger a dialog
class AccountSubscriptionsEdit extends Base {
	constructor(el) {
		super(el);

		this.on('change');

		this.toggleGtmClickTracking(this.el.checked);

		if (this.options.preferredBrokerWarning) {
			this.on('click');

			document.body.addEventListener(accountEvents.ITEM_EDIT_ALLOWS_CONTACT, e => this.onChangeAllowsContact(e));
		}
	}

	onChange(e) {
		this.toggleGtmClickTracking(e.target.checked);
	}

	onClick(e) {
		if (e.target.checked) {
			return;
		}

		e.preventDefault();

		AccountSubscriptionsEdit.createDialog();
	}

	static createDialog() {
		const tagName = 'x-account-subscriptions-edit-form';
		const title = 'Products and Services';

		constructDialog({ title }, tagName);
	}

	onChangeAllowsContact(e) {
		const { isChecked } = e.detail;

		this.el.checked = isChecked;

		if (!isChecked) {
			const changeEvent = new Event('change', { bubbles: true });

			this.el.dispatchEvent(changeEvent);
		}
	}

	toggleGtmClickTracking(isChecked) {
		const el = this.query('.js-submit-button', document.body);

		if (isChecked) {
			el.dataset.gtmClick = true;

			return;
		}

		delete el.dataset.gtmClick;
	}
}

export default AccountSubscriptionsEdit;
